import { Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'md-create-page-header',
  imports: [MatIconModule],
  templateUrl: './create-page-header.component.html',
  styleUrl: './create-page-header.component.scss',
  standalone: true
})
export class CreatePageHeaderComponent {
  title = input<string>('Otsikko');
  icon = input<string>('customer');
}
